import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { TextButton } from '@/shared/ui'

import { SubHeading } from '../../common'
import { RoomDialogTrigger, RoomList } from '../room-dialog'

export const ROW_DISPLAY_COUNT = 3
const MAX_OTHER_HOST_ROOMS = 6

type Props = Pick<TRoomDetail, 'otherHostRooms'> & {
  disabled?: boolean
}

export const OtherRooms = ({
  otherHostRooms: otherHostRoomsProp,
  disabled = false,
}: Props) => {
  const t = useTranslations('room_detail')

  const otherHostRooms = otherHostRoomsProp.slice(0, MAX_OTHER_HOST_ROOMS)

  const isMoreThanMaxOtherHostRooms =
    otherHostRoomsProp.length > MAX_OTHER_HOST_ROOMS

  if (otherHostRooms.length === 0) {
    return null
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <SubHeading className="typo-body2">
          {t('landlord_profile.other_unit')}
        </SubHeading>
        {isMoreThanMaxOtherHostRooms && (
          <RoomDialogTrigger otherHostRooms={otherHostRoomsProp}>
            <TextButton color="gray" size="small" disabled={disabled}>
              {t('landlord_profile.button.view_all')}
            </TextButton>
          </RoomDialogTrigger>
        )}
      </div>

      <RoomList otherHostRooms={otherHostRooms} disabled={disabled} />
    </div>
  )
}
